var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tab-pane fade in active",
      attrs: { id: "tab_performance" }
    },
    [
      _c("div", { staticClass: "tab__header" }, [
        _vm._v("Performance Evaluation")
      ]),
      _vm._v(" "),
      _c("Benchmarks", {
        attrs: { "practice-benchmark": _vm.practiceBenchmark }
      }),
      _vm._v(" "),
      _c("Comparisons"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "kpi__table-container kpi__table-container--bordered" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "table",
            { staticClass: "kpi-performance-table" },
            [
              _c("TableHead", {
                attrs: {
                  title: "KPI",
                  "month-year-string": _vm.monthYearString
                }
              }),
              _vm._v(" "),
              _c("TableSubHead"),
              _vm._v(" "),
              _vm._l(_vm.metricsKpiTracking, function(metric, index) {
                return _c(_vm.getComponentName(metric.field), {
                  key: "kpi-tracking-" + metric.field + "-" + index,
                  tag: "component",
                  attrs: { metric: metric }
                })
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "legend" }, [
            _vm._v("BMK = Benchmark of similar sized practices.")
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c(
            "table",
            { staticClass: "kpi-performance-table" },
            [
              _c("TableHead", {
                attrs: {
                  title: "KPI",
                  "month-year-string": _vm.monthYearString
                }
              }),
              _vm._v(" "),
              _c("TableSubHead"),
              _vm._v(" "),
              _vm._l(_vm.metricsLocationsAndProviders, function(metric, index) {
                return _c(_vm.getComponentName(metric.field), {
                  key: "locations-providers-" + index,
                  tag: "component",
                  attrs: { metric: metric }
                })
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "legend" }, [
            _vm._v("BMK = Benchmark of similar sized practices.")
          ]),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c(
            "table",
            { staticClass: "kpi-performance-table" },
            [
              _c("TableHead", {
                attrs: {
                  title: "KPI",
                  "month-year-string": _vm.monthYearString
                }
              }),
              _vm._v(" "),
              _c("TableSubHead"),
              _vm._v(" "),
              _vm._l(_vm.metricsTestingStatistics, function(metric, index) {
                return _c(_vm.getComponentName(metric.field), {
                  key: "testing-" + index,
                  tag: "component",
                  attrs: { metric: metric }
                })
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "legend" }, [
            _vm._v("BMK = Benchmark of similar sized practices.")
          ]),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _c(
            "table",
            { staticClass: "kpi-performance-table" },
            [
              _c("TableHead", {
                attrs: {
                  title: "KPI",
                  "month-year-string": _vm.monthYearString
                }
              }),
              _vm._v(" "),
              _c("TableSubHead"),
              _vm._v(" "),
              _vm._l(_vm.metricsTreatmentStatistics, function(metric, index) {
                return _c(_vm.getComponentName(metric.field), {
                  key: "treatment-" + index,
                  tag: "component",
                  attrs: { metric: metric }
                })
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "legend" }, [
            _vm._v("BMK = Benchmark of similar sized practices.")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid h-unset-max-width" }, [
      _c("div", { staticClass: "grid__col--6" }, [
        _c("div", { staticClass: "tab__sub-header" }, [_vm._v("KPI TRACKING")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid__col--6" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid h-unset-max-width" }, [
      _c("div", { staticClass: "grid__col--6" }, [
        _c("div", { staticClass: "tab__sub-header" }, [
          _vm._v("PRACTICE LOCATIONS & PROVIDER INFORMATION")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid__col--6" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid h-unset-max-width" }, [
      _c("div", { staticClass: "grid__col--6" }, [
        _c("div", { staticClass: "tab__sub-header" }, [
          _vm._v("TESTING STATISTICS")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid__col--6" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid h-unset-max-width" }, [
      _c("div", { staticClass: "grid__col--6" }, [
        _c("div", { staticClass: "tab__sub-header" }, [
          _vm._v("TREATMENT STATISTICS")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid__col--6" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }